var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardHeroBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1035,
    height: 276,
    viewBox: "0 0 1035 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_n_1581_2233)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1581_2233)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1035,
    height: 276,
    rx: 12,
    fill: "#B73601"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1073,
    y1: 215.45,
    x2: -7,
    y2: 215.45,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.899746
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.4064,
    cy: 83.4064,
    r: 82.9565,
    transform: "matrix(-1 0 0 1 1072.81 154)",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.899746
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.449873,
    x2: 328.418,
    y2: -0.449873,
    transform: "matrix(0 -1 -1 0 968.094 299.419)",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.899746
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1581_2233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 -47.5L185.5 -63L311 101H34L120 -47.5Z",
    fill: "url(#paint0_linear_1581_2233)",
    fillOpacity: 0.3
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_n_1581_2233",
    x: 0,
    y: 0,
    width: 1035,
    height: 276,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "10 10",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 8682
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_1581_2233"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1581_2233",
    x: -185.7,
    y: -282.7,
    width: 716.4,
    height: 603.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 109.85,
    result: "effect1_foregroundBlur_1581_2233"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1581_2233",
    x1: 172.5,
    y1: -103,
    x2: 172.5,
    y2: 101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1581_2233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1035,
    height: 276,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardHeroBg);
export default __webpack_public_path__ + "static/media/DashboardHeroBg.63fd884c146cf7d8244f2a72147e1501.svg";
export { ForwardRef as ReactComponent };